module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-step-01-454ba920f9cb1698e6879ebed12e1bde.jpg";